import { Check } from "lucide-react";
import { Reveal, Chapter, IMAGES } from "@/components/Shared";

const VALUES = [
  "Safe and nurturing environment",
  "Dependable care for working families",
  "Individual attention for every child",
  "Age-appropriate activities",
  "Learning through play",
  "Social and emotional development",
  "Open family communication",
  "Clean and organized environment",
];

const About = () => (
  <section id="about" data-testid="about-section" className="relative py-24 sm:py-32">
    <div className="mx-auto grid max-w-7xl gap-14 px-5 sm:px-8 lg:grid-cols-[0.9fr_1.1fr] lg:items-center">
      <Reveal className="relative order-2 lg:order-1">
        <div className="arch-frame overflow-hidden border-[6px] border-white shadow-2xl shadow-deepteal/20 max-w-md mx-auto">
          <img
            src={IMAGES.about}
            alt="Diverse group of Black and white children doing arts and crafts at Pieces to Our Puzzle Childcare, daycare in Halethorpe Maryland"
            className="h-[420px] sm:h-[500px] w-full object-cover"
            loading="lazy"
          />
        </div>
        <div className="absolute -bottom-6 left-1/2 -translate-x-1/2 lg:left-auto lg:-right-4 lg:translate-x-0 rounded-2xl bg-deepteal px-6 py-4 shadow-xl">
          <p className="font-serif text-2xl text-amber-200">Ms. Bre</p>
          <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-amber-100/70">
            Licensed MD Childcare Provider
          </p>
        </div>
      </Reveal>

      <div className="order-1 lg:order-2">
        <Reveal>
          <Chapter num="01" label="About Us" />
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-medium tracking-tight leading-[1.12] text-deepteal-dark">
            Where every child feels <em className="italic text-terracotta">valued</em>, supported, and ready to grow.
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mt-6 text-base sm:text-lg leading-relaxed text-slate-600">
            Pieces to Our Puzzle Childcare provides a safe, caring, structured, and nurturing
            environment where children can learn, grow, socialize, and feel valued. Led by Ms. Bre,
            a licensed Maryland childcare provider, our Halethorpe childcare program is built around
            one belief: every child is an important piece of the puzzle.
          </p>
          <p className="mt-4 text-base sm:text-lg leading-relaxed text-slate-600">
            Our goal is to partner with families and provide dependable childcare while supporting
            each child's social, emotional, educational, and developmental growth — seven days a week.
          </p>
        </Reveal>
        <Reveal delay={0.18}>
          <ul className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-3.5" data-testid="about-values-list">
            {VALUES.map((v) => (
              <li key={v} className="flex items-start gap-3">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-amber-500/15 text-terracotta">
                  <Check className="h-3 w-3" strokeWidth={3} />
                </span>
                <span className="text-sm font-semibold text-slate-700">{v}</span>
              </li>
            ))}
          </ul>
        </Reveal>
      </div>
    </div>
  </section>
);

export default About;
